export const componentTypes = {
  TEXT: 'text',
  IMAGE: 'image',
  BUTTON: 'button',
  YOUTUBE: 'youtube',
  MP4VIDEO: 'mp4',
  SPOTIFY: 'spotify',
  SOUNDCLOUD: 'soundcloud',
  BAINREFERRALBANNER: 'bain referral banner',
  ADVERTISERDISCLOSURE: 'advertiser disclosure',
  ACCORDION: 'accordion',
  CURRENTDATE: 'current date',
  LOTTIE: 'lottie',
};
